(function () {
  function init(root) {
    if (root.dataset.vcEtaReady === 'true') return;
    root.dataset.vcEtaReady = 'true';
    var country = root.querySelector('[data-vc-eta-country]');
    var result = root.querySelector('[data-vc-eta-result]');
    var arrival = root.querySelector('[data-vc-eta-arrival]');
    var action = root.querySelector('[data-vc-eta-action]');
    var estimateText = root.querySelector('[data-vc-eta-estimate-text]');
    var arrivalDate = root.querySelector('[data-vc-eta-date]');
    var note = root.querySelector('[data-vc-eta-note]');
    var section = root.closest('[data-fg-product-section]') || root.closest('.shopify-section') || root.parentElement;
    var variantInput = section && (section.querySelector('form[data-type="add-to-cart-form"] [name="id"]') ||
      section.querySelector('form[action*="/cart/add"] [name="id"]'));
    var productForm = variantInput && variantInput.closest('form');
    var estimatePropertyName = 'properties[_VC shipping estimate]';
    var activeRequest;
    var sequence = 0;
    var lastKey = '';
    var pluginCheck;
    var cacheLifetime = 15 * 60 * 1000;
    var pluginGracePassed = false;

    function isoDate(value) {
      var text = String(value || '').trim();
      var match = text.match(/\b(\d{4})-(\d{1,2})-(\d{1,2})\b/);
      if (!match) {
        match = text.match(/\b(\d{1,2})(?:st|nd|rd|th)?\s+(January|February|March|April|May|June|July|August|September|October|November|December)\s+(\d{4})\b/i);
        if (match) {
          var months = 'january february march april may june july august september october november december'.split(' ');
          match = [match[0], match[3], String(months.indexOf(match[2].toLowerCase()) + 1), match[1]];
        }
      }
      if (!match) return '';
      var year = Number(match[1]), month = Number(match[2]), day = Number(match[3]);
      var date = new Date(Date.UTC(year, month - 1, day));
      if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return '';
      return date.toISOString().slice(0, 10);
    }

    function currentVariant() {
      function matchOptions(options) {
        var mappings = root.querySelectorAll('[data-vc-eta-variant]');
        for (var i = 0; i < mappings.length; i++) {
          var entry = mappings[i];
          try {
            var values = JSON.parse(entry.getAttribute('data-options'));
            if (values.length === options.length && values.every(function (value, index) { return value === options[index]; })) {
              return entry.getAttribute('data-vc-eta-variant');
            }
          } catch (_) { /* Keep the form or Liquid fallback. */ }
        }
        return '';
      }
      var pressed = section && section.querySelectorAll('[data-option-index][aria-pressed="true"]');
      if (pressed && pressed.length) {
        var options = Array.from(pressed).sort(function (a, b) {
          return Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex);
        }).map(function (button) { return button.dataset.optionValue; });
        var selected = matchOptions(options);
        if (selected) return selected;
      }
      var legacy = section && section.querySelectorAll(
        'variant-radios fieldset[data-option-index] input.product-form__radio:checked, variant-selects [data-option-index] select'
      );
      if (legacy && legacy.length) {
        var choices = Array.from(legacy).sort(function (a, b) {
          return Number(a.closest('[data-option-index]').dataset.optionIndex) - Number(b.closest('[data-option-index]').dataset.optionIndex);
        }).map(function (input) { return input.value; });
        var legacyVariant = matchOptions(choices);
        if (legacyVariant) return legacyVariant;
      }
      return variantInput && /^\d+$/.test(variantInput.value) ? variantInput.value : root.dataset.variantId;
    }

    function variantCanBeOrdered(variant) {
      var entry = root.querySelector('[data-vc-eta-variant="' + variant + '"]');
      return !entry || entry.getAttribute('data-vc-eta-available') !== 'false';
    }

    function isPreorder() {
      return !!root.dataset.preorderDate || root.dataset.preorderProduct === 'true' || !!(section && section.querySelector(
        '.fgp-buy-row [data-fg-bundle-preorder], .fgp-buy-row .fgp-preorder-link, .fgp-buy-row [data-pre-order-atc-button], .productView-buttons #pre_order_custom, .productView-buttons [data-pre-order-atc-button="1"], .productView-buttons .spurit-po-wrapper'
      ));
    }

    function rememberedDate(variant) {
      try {
        var saved = JSON.parse(sessionStorage.getItem('vc-eta-preorder:' + variant) || 'null');
        return saved && Date.now() - saved.savedAt < cacheLifetime && saved.savedAt <= Date.now()
          ? isoDate(saved.date) : '';
      } catch (_) { return ''; }
    }

    function rememberDate(variant, date) {
      try { sessionStorage.setItem('vc-eta-preorder:' + variant, JSON.stringify({ date: date, savedAt: Date.now() })); }
      catch (_) { /* Storage can be disabled; live sources remain usable. */ }
    }

    function dispatchDate(variant) {
      var date = isoDate(root.dataset.preorderDate);
      if (!date && section) {
        var source = section.querySelector('.estimated-shipping-date-wrapper[id="shipping_date_' + variant + '"] .shipping-info');
        if (!source) source = section.querySelector('.estimated-shipping-date-wrapper[id="shipping_date_' + variant + '"]');
        date = source ? isoDate(source.textContent) : '';
      }
      if (date) {
        rememberDate(variant, date);
        return date;
      }
      return rememberedDate(variant);
    }

    function syncCartEstimate(countryCode, preorderDate, data) {
      if (!productForm) return;
      var input = productForm.querySelector('[name="' + estimatePropertyName + '"]');
      var hasEstimate = data && ['available', 'preorder'].includes(data.status) &&
        (data.status !== 'available' || variantCanBeOrdered(currentVariant())) &&
        Number.isInteger(data.minBusinessDays) && Number.isInteger(data.maxBusinessDays) &&
        typeof data.isLocal === 'boolean';
      if (!preorderDate && !hasEstimate) {
        if (input) input.remove();
        return;
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = estimatePropertyName;
        productForm.appendChild(input);
      }
      var value = { version: 1, country: countryCode, preorderDate: preorderDate || '' };
      if (hasEstimate) {
        value.method = data.isLocal ? 'local' : 'international';
        value.minDays = data.minBusinessDays;
        value.maxDays = data.maxBusinessDays;
      }
      input.value = JSON.stringify(value);
    }

    function setState(state) {
      root.classList.remove('is-loading', 'is-available', 'is-preorder', 'is-preorder-pending', 'is-unavailable');
      root.classList.add('is-' + state);
      result.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
      if (section) section.setAttribute('data-vc-eta-preorder', state === 'preorder' || state === 'preorder-pending' ? 'true' : 'false');
    }
    function dateRange(label) {
      var value = String(label || '').trim();
      var prefix = String(root.dataset.arrivesLabel || 'Arrives').trim();
      if (prefix && value.toLowerCase().indexOf(prefix.toLowerCase()) === 0) {
        return value.slice(prefix.length).trim();
      }
      return value;
    }
    function displayDate(value) {
      var date = value && new Date(value + 'T00:00:00Z');
      if (!date || Number.isNaN(date.getTime())) return '';
      var options = { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' };
      return date.toLocaleDateString('en-US', options);
    }
    function plainMessage(message) {
      action.textContent = '';
      estimateText.textContent = '';
      arrivalDate.textContent = message || '';
      arrival.setAttribute('aria-label', message || '');
    }
    function estimateMessage(status, label) {
      var lead = status === 'preorder'
        ? (root.dataset.preorderTodayLabel || 'Pre-order today')
        : (root.dataset.orderTodayLabel || 'Order today');
      var connector = root.dataset.estimatedDeliveryLabel || 'for estimated delivery';
      var date = dateRange(label);
      action.textContent = lead;
      estimateText.textContent = ' ' + connector + ' ';
      arrivalDate.textContent = date;
      arrival.setAttribute('aria-label', [lead, connector, date].filter(Boolean).join(' '));
    }
    function fallback(preorderDate, variant) {
      setState('unavailable');
      if (!preorderDate && variant && !variantCanBeOrdered(variant)) {
        plainMessage(root.dataset.variantUnavailableTitle || 'This item is unavailable for delivery');
        note.textContent = '';
        return;
      }
      plainMessage(root.dataset.errorTitle || 'Delivery estimate unavailable right now');
      var dateLabel = displayDate(preorderDate);
      note.textContent = dateLabel
        ? root.dataset.preorderShipTemplate.replace('{date}', dateLabel) : '';
    }
    function pendingPreorder() {
      setState('preorder-pending');
      plainMessage(root.dataset.preorderPendingTitle || 'Pre-order — shipping date to be confirmed');
      note.textContent = root.dataset.preorderPendingNote || 'Arrival estimate available once a shipping date is provided.';
    }
    function show(data, preorderDate, variant) {
      if (data && data.status === 'unavailable' && data.reason === 'unsupported_country') {
        setState('unavailable');
        plainMessage(root.dataset.unavailableTitle || 'We cannot deliver to your location');
        note.textContent = '';
        return;
      }
      if (data && data.status === 'unavailable') {
        setState('unavailable');
        plainMessage(variantCanBeOrdered(variant)
          ? (root.dataset.estimateUnavailableTitle || 'Delivery estimate unavailable')
          : (root.dataset.variantUnavailableTitle || 'This item is unavailable for delivery'));
        note.textContent = '';
        return;
      }
      if (!data || !['available', 'preorder'].includes(data.status) ||
          typeof data.arrivalLabel !== 'string') {
        fallback(preorderDate, variant);
        return;
      }
      if (data.status === 'available' && !variantCanBeOrdered(variant)) {
        setState('unavailable');
        plainMessage(root.dataset.variantUnavailableTitle || 'This item is unavailable for delivery');
        note.textContent = '';
        return;
      }
      setState(data.status);
      estimateMessage(data.status, data.arrivalLabel);
      var dateLabel = displayDate(data.preorderDate);
      note.textContent = data.status === 'preorder' && dateLabel
        ? root.dataset.preorderShipTemplate.replace('{date}', dateLabel) : '';
    }
    function update() {
      var variant = currentVariant();
      var countryCode = country ? country.value : root.dataset.countryCode;
      var preorder = isPreorder();
      if (!preorder && !pluginGracePassed) return;
      var date = preorder ? dispatchDate(variant) : '';
      var key = [variant, countryCode, preorder, date].join('|');
      if (key === lastKey) return;
      lastKey = key;
      var requestId = ++sequence;
      if (activeRequest) activeRequest.abort();
      activeRequest = null;
      syncCartEstimate(countryCode, date, null);
      if (!/^\d+$/.test(variant || '') || !/^[A-Z]{2}$/.test(countryCode || '')) {
        fallback(date, variant);
        return;
      }
      if (preorder && !date) {
        pendingPreorder();
        return;
      }
      var params = new URLSearchParams({ variantId: 'gid://shopify/ProductVariant/' + variant, countryCode: countryCode });
      if (date) params.set('preorderDate', date);
      var controller = new AbortController();
      activeRequest = controller;
      var timeout = setTimeout(function () { controller.abort(); }, 2000);
      setState('loading');
      plainMessage(root.dataset.checking);
      note.textContent = '';
      fetch('/apps/shipping-eta?' + params.toString(), { signal: controller.signal, credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('estimate unavailable'); return response.json(); })
        .then(function (data) {
          if (requestId !== sequence) return;
          show(data, date, variant);
          syncCartEstimate(countryCode, date, data);
        })
        .catch(function () { if (requestId === sequence) fallback(date, variant); })
        .finally(function () { clearTimeout(timeout); if (activeRequest === controller) activeRequest = null; });
    }
    if (country) country.addEventListener('change', update);
    if (variantInput) {
      variantInput.addEventListener('change', update);
      section.addEventListener('click', function (event) {
        if (event.target.closest('[data-option-index]')) setTimeout(function () {
          update();
        }, 0);
      });
      section.addEventListener('change', function (event) {
        if (event.target.closest('variant-radios, variant-selects')) setTimeout(update, 0);
      });
    }
    document.addEventListener('variant:change', function () { setTimeout(update, 0); });
    document.addEventListener('variant:changed', function () { setTimeout(update, 0); });
    if (section && section.querySelector('.fgp-buy-row') && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        clearTimeout(pluginCheck);
        pluginCheck = setTimeout(update, 80);
      }).observe(section.querySelector('.fgp-buy-row'), { childList: true, subtree: true, characterData: true });
    }
    if (section && section.querySelector('[data-fg-preorder-arrival]') && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        clearTimeout(pluginCheck);
        pluginCheck = setTimeout(update, 80);
      }).observe(section.querySelector('[data-fg-preorder-arrival]'), { childList: true, subtree: true, characterData: true });
    }
    if (typeof window !== 'undefined') window.addEventListener('pageshow', function () {
      lastKey = '';
      update();
    });
    setTimeout(function () { pluginGracePassed = true; update(); }, 1200);
    [350, 1000, 2500, 5000, 10000].forEach(function (delay) { setTimeout(update, delay); });
    update();
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vc-shipping-eta]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
